declare global {
  interface Window {
    pendo: any;
  }
}

type PendoTrackData = {
  // RADAR-8055 Discovery details is in a Panel and thus cannot be tracked via URL
  discovery_details_open: {
    project_id: string;
    project_name: string;
    workspace_id: string;
    workspace_name: string;
  };
};
type PendoTrackName = keyof PendoTrackData;

export function pendoTrack<T extends PendoTrackName>(
  name: T,
  data: PendoTrackData[T]
) {
  if (window.pendo && window.pendo.isReady && window.pendo.isReady()) {
    return window.pendo.track(name, data);
  }
}
